$(document).ready(function () {
    $('#newsletter-form').submit(function (e) {
        e.preventDefault();
        $.ajax({
            type: "POST",
            url: $('#newsletter-form').attr('action'),
            data: $('#newsletter-form').serialize(),
            success: function () {
                $('#newsletter-form-error').hide();
                $('#newsletter-form-submit').prop('disabled', true);
                $('#newsletter-form-success').show();
            },
            error: function (response) {
                $('#newsletter-form-error').show();
                $('#newsletter-form-error').html(response.responseJSON.data.email);
            }
        });
    });

    $.ajaxSetup({
        beforeSend: function (xhr, settings) {
            if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type) && !this.crossDomain) {
                xhr.setRequestHeader("X-CSRFToken", "{{ newsletter_form.csrf_token._value() }}");
            }
        }
    })
});



// WEBPACK FOOTER //
// ./herbal/static/js/script.js